import {useRecoilValue} from "recoil";
import {FortuneResultData} from "src/store/UserPage/fortune";
import {
    FortuneResultDescSection,
    FortuneResultImg,
    FortuneResultImgSection,
    FortuneResultWrap
} from "src/styles/views/UserPage/Fortune";

import luck0Img from 'src/assets/main/main7/main7luck_icon0.png'
import luck1Img from 'src/assets/main/main7/main7luck_icon1.png'
import luck2Img from 'src/assets/main/main7/main7luck_icon2.png'
import luck3Img from 'src/assets/main/main7/main7luck_icon3.png'
import luck4Img from 'src/assets/main/main7/main7luck_icon4.png'
import React, {useState} from "react"
import useWindowDimensions from "src/hooks/useGetWindowSize";

const ResultImgList = [
    {text: "총운", ImgSrc: luck0Img},
    {text: "직장운", ImgSrc: luck1Img},
    {text: "금전운", ImgSrc: luck2Img},
    {text: "소원운", ImgSrc: luck3Img},
    {text: "방위운", ImgSrc: luck4Img},
]

const BirthFortuneResult = () => {
    const UserFortuneData: any = useRecoilValue(FortuneResultData)
    const [Choice, seChoice] = useState("총운")
    const { width } = useWindowDimensions()
     const ChoiceItems = UserFortuneData?.TodayUnses?.find((element: { Title: string, Contents: string }) => element?.Title === Choice)
    return (
        <>
            <h3>오늘의 운세</h3>
            <FortuneResultWrap>
                <FortuneResultImgSection className='birth'>
                    {ResultImgList.map((element: { text: string, ImgSrc: string }) => (
                        <section key={element.text}>
                            <FortuneResultImg
                                active={Choice === element.text}
                                onClick={() => seChoice(element.text)}
                                size={width > 1200 ? "100px" : "72px"}
                            >
                                <img className="birth" src={element.ImgSrc} alt=""/>
                            </FortuneResultImg>
                            <p>{element.text}</p>
                        </section>
                    ))}
                </FortuneResultImgSection>
                <FortuneResultDescSection>
                    <pre>{ChoiceItems?.Contents}</pre>
                </FortuneResultDescSection>
            </FortuneResultWrap>
        </>
    )
}
export default BirthFortuneResult